import { t } from '~/utils/i18n';

export const IMPORTER_TOTAL_PROGRESS = 3;

export const IMPORTER_FORGOT_PASSWORD = {
  title: t('importer.resetPassword'),
  url: 'https://www.landing.abihome.de/reset',
  version: '1',
};
